import { motion } from "framer-motion";
import { useLanguage } from "@/i18n/LanguageContext";

const CHAPTER_IMAGES = ["/images/players.jpg", "/images/action.jpg", "/images/boots.jpg", "/images/ball.jpg", "/images/pitch.jpg"];
const CHAPTER_TESTIDS = [
  "teamup-chapter-find-matches",
  "teamup-chapter-join-games",
  "teamup-chapter-create-matches",
  "teamup-chapter-connect-players",
  "teamup-chapter-football-anywhere",
];

const ease = [0.16, 1, 0.3, 1];

export const Manifesto = () => {
  const { t } = useLanguage();

  return (
    <section id="about" data-testid="teamup-about-manifesto-section" className="relative mx-auto max-w-7xl px-5 py-28 sm:px-8 md:py-36">
      <motion.div
        initial={{ opacity: 0, y: 32 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease }}
        className="mb-20 max-w-3xl md:mb-28"
      >
        <p className="mb-5 font-mono text-[11px] uppercase tracking-[0.3em] text-brand sm:text-xs">{t.about.eyebrow}</p>
        <h2 className="font-display text-3xl font-extrabold uppercase leading-[1.05] tracking-tight text-white sm:text-5xl lg:text-6xl">
          {t.about.heading}
        </h2>
        <p className="mt-6 max-w-xl text-base leading-relaxed text-mist sm:text-lg">{t.about.intro}</p>
      </motion.div>

      <div>
        {t.about.chapters.map((ch, i) => (
          <motion.article
            key={ch.num}
            data-testid={CHAPTER_TESTIDS[i]}
            initial={{ opacity: 0, y: 44 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, ease, delay: 0.05 }}
            className="group grid grid-cols-1 items-center gap-8 border-t border-white/[0.07] py-14 md:grid-cols-12 md:gap-10 md:py-16"
          >
            <div className="md:col-span-2">
              <span className="font-mono text-sm font-bold uppercase tracking-[0.25em] text-brand">{ch.num}</span>
              <span className="mt-3 block h-px w-10 bg-brand/30 transition-all duration-500 group-hover:w-16 group-hover:bg-brand" />
            </div>
            <h3 className="font-display text-2xl font-bold uppercase leading-tight tracking-tight text-white transition-colors duration-500 group-hover:text-brand sm:text-4xl md:col-span-4">
              {ch.title}
            </h3>
            <p className="text-sm leading-relaxed text-mist sm:text-base md:col-span-3">{ch.desc}</p>
            <div className={`md:col-span-3 ${i % 2 === 1 ? "md:order-first md:-ml-0" : ""}`}>
              <div className="overflow-hidden rounded-xl border border-white/[0.07] transition-colors duration-500 group-hover:border-brand/30">
                <motion.img
                  src={CHAPTER_IMAGES[i]}
                  alt={ch.title}
                  loading="lazy"
                  className="h-44 w-full object-cover grayscale-[35%] transition-all duration-700 ease-out group-hover:scale-105 group-hover:grayscale-0 md:h-52"
                />
              </div>
            </div>
          </motion.article>
        ))}
      </div>
    </section>
  );
};
